<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório estatístico de atendimentos">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/atencao-basica/relatorio-estatistico-atendimento/List'

export default {
    components: { List },
}
</script>
